import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=66a5db80&"
import script from "./Food.vue?vue&type=script&lang=js&"
export * from "./Food.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports